import { StarMark } from "../ui/StarMark";
import { PhotoCarousel } from "./PhotoCarousel";
import "./EditorialTiles.css";

/** Galeria editorial de fotografias mediterrânies. */
export function EditorialTiles({ title = "Una editorial amb arrels mediterrànies" }: { title?: string }) {
	return (
		<section
			className="editorial-tiles"
			id="nosaltres"
			aria-labelledby="editorial-tiles-title"
		>
			<h2 className="editorial-tiles__title" id="editorial-tiles-title">
				<StarMark className="editorial-tiles__star" />
				{title}
			</h2>

			<PhotoCarousel />
		</section>
	);
}
